import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedIdrDashboardRecommendationsController extends Controller {
  @tracked recommendation = '';

  queryParams = ['recommendation'];
}
